import moment, {Moment} from 'moment-timezone';
import {MeterType, MeterUtilityType} from '@app/graphql-typings/graphql';

export enum MeterdataType {
  ACTIVE_IMPORT = 'active_import',
  ACTIVE_EXPORT = 'active_export',
  REACTIVE_IMPORT = 'reactive_import',
  REACTIVE_EXPORT = 'reactive_export',
  ACTIVE_NET = 'active_net',
  REACTIVE_NET = 'reactive_net',
  DEMAND = 'demand'
}


export interface SeriesData {
  data?: number;
  normalisation?: number;
  cost?: number;
  emissions?: number;
}


export interface TimeSeriesData extends SeriesData {
  ts: Moment;
  update?: boolean;
}


export enum QualityFlag {
  ACTUAL = 'A',
  FINAL_SUBSTITUED = 'F',
  SUBSTITUTED = 'S',
  ESTIMATED = 'E',
  CIM_ESTIMATED = 'C'
}


export interface MeterHistoryQualityItem extends SeriesData {
  quality_flag: QualityFlag;
}


export interface MeterHistoryTimeSeriesData extends TimeSeriesData {
  quality_breakdown?: MeterHistoryQualityItem[];
}

export type MeterProviderId = number;
export type MeterId = number;
export type StreamId = string;

export interface MeterIdStreamId {
  nmi_id: MeterId;
  stream_id: StreamId;
}

export interface Meterdata {
  nmi_number: string;
  stream_id: string;
  nmi_id?: number;
  // currently meter data history API will need either nmi_id or (nmi_number, provider_id) to resolve the meter record
  provider_id?: number;
  data_type?: MeterdataType;
  meter_type: MeterType;
  utility_type: MeterUtilityType;
  data: TimeSeriesData[];
}


export interface SimpleMeterdataHistory {
  nmi_id: number;
  stream_id: string;
  site_id: number;
  data: MeterHistoryTimeSeriesData[];
  data_type?: MeterdataType;
}


export interface MeterDataHistoryLoadResponse {
  status: string;
  data: {
    meterdata_history: SimpleMeterdataHistory[];
  };
}


export interface MeterDataHistoryPostResponse {
  meterdata_history: {
    items: number;
  };
}


export const MeterIntervalUnits: moment.unitOfTime.Base[] = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'];
